import { Tabs } from "devextreme-react";
import { useState } from "react";
import SiteContractStatus from "./SiteContractStatus";
import SitePaymentStatus from "./SitePaymentStatus";

export default function SiteContract(props) {
  const { sales } = props;

  const [siteContractType, setSiteContractType] =
    useState("siteContractStatus");
  const [dataSource, setDataSource] = useState([
    {
      text: "Site Contract Status",
      type: "siteContractStatus",
    },
    {
      text: "Site Payment Status",
      type: "sitePaymentStatus",
    },
  ]);

  const itemRender = (e) => {
    return (
      <div
        style={{
          fontSize: "16px",
          fontWeight: "bold",
          color: "black",
          textTransform: "none",
        }}
      >
        {e.text}
      </div>
    );
  };

  const onItemClick = (e) => {
    setSiteContractType(e.itemData.type);
  };

  return (
    <>
      <Tabs
        dataSource={dataSource}
        defaultSelectedIndex={0}
        height={40}
        // width={450}
        width={"auto"}
        itemRender={itemRender}
        onItemClick={onItemClick}
      />
      {siteContractType == "siteContractStatus" && (
        <SiteContractStatus sales={sales} />
      )}
      {siteContractType == "sitePaymentStatus" && (
        <SitePaymentStatus sales={sales} />
      )}
    </>
  );
}
